module.exports = __webpack_public_path__ + "img/02.719f2935.png";